import { GenericError } from '@cian/peperrors/shared';
export class TelemetryError extends GenericError {
    constructor({ message, domain, details }) {
        super({
            type: 'TelemetryError',
            message,
            domain,
            details,
        });
        Object.setPrototypeOf(this, TelemetryError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, TelemetryError);
        }
        else {
            this.stack = new Error().stack;
        }
    }
}
//# sourceMappingURL=errors.js.map